/* unplugin-vue-components disabled */import { render } from "./StakeLeftChart.vue?vue&type=template&id=47f18d29"
import script from "./StakeLeftChart.vue?vue&type=script&lang=js"
export * from "./StakeLeftChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__